import { useContext } from 'react'
import { ApiClientContext } from './contexts.js'

// The bound HTTP client: { request, get, post, patch, put, del } — see
// createApiClient in client.js. Use for imperative calls (mutations):
//
//   const api = useApiClient()
//   await api.post('/api/v1/messages', { recipient_id, content })
export function useApiClient() {
  const client = useContext(ApiClientContext)
  if (!client) throw new Error('useApiClient must be used within ApiProvider')
  return client
}
